import * as React from 'react';
import { Modal } from 'rcd-cpp-ui/ui/modal/Modal';
import { Primary, Buttons, Cancel } from 'rcd-cpp-ui/ui/button';
import { useAlert } from '../../Alert/alert';
import { useLoader } from '../../Loader/loader';
import { FileUpload } from '../../FileUpload/fileUpload';
import { useToaster } from '../../Toaster/toaster';
import { ManagedData, ManagedDataImport } from '../../../types/ManagedData';
import { useActions } from './importManagedDataModalActions';

type ValidationResult = {
  managedData: ManagedData;
  report: { [x: string]: number };
  managedDataImport?: ManagedDataImport;
};

export const ImportManagedDataModal = ({ onClose }) => {
  const [file, setFile] = React.useState<File>(null);
  const [validationResult, setValidationResult] =
    React.useState<ValidationResult>(null);
  const { ...actions } = useActions();
  const {
    isLoading,
    Loader,
    Alert,
    setMessage,
    validateManagedDataFile,
    importManagedData
  } = useAlert(useLoader(actions));
  const toaster = useToaster();
  React.useEffect(() => {
    const validateFile = async () => {
      setValidationResult(null);
      setMessage(null);
      if (file) {
        validateManagedDataFile(file).then(result => {
          setValidationResult(result as any);
        });
      }
    };
    validateFile();
  }, [file]);
  return (
    <Modal
      id="importManageDataModal"
      onClose={onClose}
      header="Import"
      footer={
        <Buttons>
          <Cancel onClick={onClose} />
          <Primary
            label="Import"
            onClick={() => {
              importManagedData(
                validationResult.managedDataImport,
                validationResult.managedData,
                toaster,
                onClose
              );
            }}
            disabled={!validationResult?.managedData || isLoading}
          />
        </Buttons>
      }
    >
      <div className="metadata-form scrollable">
        <Alert />
        <Loader />
        <FileUpload
          disabled={isLoading}
          fileTypes={['.rpjs']}
          uploadFile={setFile}
          buttonLabel="Select File"
          fileNamePlaceholder="Choose a rpjs file"
        />
        {!!validationResult?.report && (
          <div>
            {Object.entries(validationResult.report)
              .filter(([k, v]) => v !== null)
              .map(([k, v]) => (
                <div key={k}>
                  <label>{k}:&nbsp;</label>
                  {v}
                </div>
              ))}
          </div>
        )}
      </div>
    </Modal>
  );
};
